import React, { useState } from "react";
import IconButton from "../iconButton";

export default function HideToggle({
    hide,
    setHide
}) {

    return (
        <div style={{ zIndex: 1, }}>
            <IconButton
                size={30}
                iconName={hide ? 'arrow-down-1' : 'arrow-up-1'}
                buttonType="tonal"
                tone="light"
                onClick={() => setHide(!hide)}
            />
        </div>
    );
};